import { useReducer, useRef } from "react";
import { useForm as useReactHookForm } from "react-hook-form";
import formReducer, { ACTIONS, STATUS } from "reducers/formReducer";

export default function useForm(formId, defaultValues) {
  const captchaRef = useRef(null);

  const {
    register,
    handleSubmit,
    control,
    reset,
    setError,
    formState: { errors },
  } = useReactHookForm({ defaultValues });

  const [state, dispatch] = useReducer(formReducer, {
    status: STATUS.READY,
    message: null,
  });

  const submit = handleSubmit((data) => {
    if (state.status !== STATUS.READY) {
      return true;
    }

    dispatch({ type: ACTIONS.SUBMIT });

    fetch("/api/webform/submit", {
      method: "POST",
      body: JSON.stringify({
        webform_id: formId,
        ...data,
      }),
    })
      .then((response) => {
        if (response.ok) {
          dispatch({
            type: ACTIONS.SUBMIT_SUCCESS,
            payload:
              "Votre message a bien été transmis. Il sera traité dans les plus brefs délais.",
          });
          reset(defaultValues);
        } else {
          response.json().then((fetchErrors) => {
            if (fetchErrors) {
              Object.keys(fetchErrors).forEach((field) => {
                setError(field, {
                  type: "custom",
                  message: fetchErrors[field],
                });
              });
            } else {
              dispatch({
                type: ACTIONS.SUBMIT_FAILURE,
                payload:
                  "Une erreur est survenue, merci de réessayer plus tard.",
              });
            }
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: ACTIONS.SUBMIT_FAILURE,
          payload: "Une erreur est survenue, merci de réessayer plus tard.",
        });
        console.error(error);
      });

    return false;
  });

  return { captchaRef, state, errors, control, register, submit };
}
